import type { Store } from '@types'
import SuperJSON from 'superjson'
import { rehydrateHistorySnapshot } from './rehydrateSnapshot'
import type { HistorySnapshot } from './types'

export function captureHistorySnapshot(state: Store): HistorySnapshot {
  const snapshot = {
    items: state.items,
    areas: state.areas,
    layers: state.layers,
    sceneBoundingBoxes: state.sceneBoundingBoxes,
    collisionableItems: state.collisionableItems,
    price: state.price,
  }
  return deserializeHistorySnapshot(serializeHistorySnapshot(snapshot))
}

export function serializeHistorySnapshot(snapshot: HistorySnapshot): string {
  return SuperJSON.stringify(snapshot)
}

export function deserializeHistorySnapshot(serialized: string): HistorySnapshot {
  return rehydrateHistorySnapshot(SuperJSON.parse(serialized) as HistorySnapshot)
}
